import axios from 'axios';
import { installerResilienceReseau } from '../utils/reseauResilience';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token d'authentification si nécessaire
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs globalement
// lot X3 — cette instance est créée par `axios.create()` : elle n'hérite PAS des intercepteurs
// de l'instance par défaut. Sans cette ligne, la liste des biens (qui passe par ici) n'aurait
// ni bandeau « Mise à jour en cours » ni réessai automatique.
installerResilienceReseau(api);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Gérer la déconnexion si nécessaire
      console.error('Unauthorized access');
    }
    return Promise.reject(error);
  }
);

export default api;
